import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EMPTY } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';
import { TaskApi } from 'shared/sdk';
import { DeliveryManagerService } from 'shared/views/pms/delivery-manager/delivery-manager.service';

@Component({
  selector: 'app-task-lookup',
  templateUrl: './task-lookup.component.html',
  styleUrls: ['./task-lookup.component.css']
})

export class TaskLookupComponent implements OnInit {

  public consoleType = [];
  public projectsByConsole: any;
  projectsByLoggedInUser: any;
  isLoading = false;

  //public projects: any = ["a6f2L0000009eaDQAQ","a6f2L0000009eaIQAQ","a6f2L0000009dpQQAQ","a6f2L0000009dt3QAA","a6f2L0000009dt4QAA","a6f2L0000009dvsQAA","a6f2L0000009dxUQAQ","a6f2L0000009dxVQAQ","a6f2L0000009eKKQAY","a6f2L0000009eKLQAY","a6f2L0000009eM1QAI","a6f2L0000009eMBQAY","a6f2L0000009eXnQAI","a6f2L0000009btpQAA","a6f2L0000009etxQAA","a6f2L0000009eu2QAA","a6f2L0000009eu7QAA","a6f2L0000009euCQAQ","a6f2L0000009euHQAQ","a6f2L0000009euMQAQ","a6f2L0000009ewSQAQ","a6f2L0000009bdNQAQ","a6f2L0000009bdOQAQ","a6f2L0000009cY9QAI","a6f2L0000009fqoQAA","a6f2L0000000OMlQAM","a6f2L0000009bicQAA","a6f2L0000009bimQAA","a6f2L0000009birQAA","a6f2L0000009bzOQAQ","a6f2L0000009c0bQAA","a6f2L0000009cQFQAY","a6f2L0000009cQUQAY","a6f2L0000009cQjQAI","a6f2L0000009cQoQAI","a6f2L0000009dEtQAI","a6f2L0000009dJUQAY","a6f2L0000009eHBQAY","a6f2L0000009eKPQAY","a6f2L0000009eRGQAY","a6f2L0000009eRLQAY","a6f2L0000009enkQAA","a6f2L0000009esLQAQ","a6f2L0000009esQQAQ","a6f2L0000009etJQAQ","a6f2L0000009f9pQAA","a6f2L0000009f9uQAA","a6f2L0000009fOuQAI","a6f2L0000009fPYQAY","a6f2L0000009ffCQAQ","a6f2L0000009foJQAQ","a6f2L0000009cOdQAI","a6f2L0000009cOxQAI","a6f2L0000009cP2QAI","a6f2L0000009cP7QAI","a6f2L0000009eL3QAI","a6f2L0000009eMpQAI","a6f2L0000009bY3QAI","a6f2L0000009c3GQAQ","a6f2L0000009e8cQAA","a6f2L0000009f9fQAA","a6f2L0000009f9gQAA","a6f2L0000009fMZQAY","a6f2L0000000OMqQAM","a6f2L0000000OOXQA2","a6f2L0000000OOmQAM","a6f2L0000000OOrQAM","a6f2L0000000OOwQAM","a6f2L0000000OPkQAM","a6f2L0000000OPpQAM","a6f2L0000000OS5QAM","a6f2L0000009cF2QAI","a6f2L0000009cMwQAI","a6f2L0000009cMxQAI","a6f2L0000009cN1QAI","a6f2L0000009cXuQAI","a6f2L0000009clmQAA","a6f2L0000009cm6QAA","a6f2L0000009domQAA","a6f2L0000009dsoQAA","a6f2L0000009e3hQAA","a6f2L0000009e3wQAA","a6f2L0000009eBgQAI","a6f2L0000009eXsQAI","a6f2L0000009eYRQAY","a6f2L0000009efbQAA","a6f2L0000009eflQAA","a6f2L0000009efvQAA","a6f2L0000009eipQAA","a6f2L0000009erDQAQ","a6f2L0000009f3AQAQ","a6f2L0000009f9VQAQ","a6f2L0000009f9aQAA","a6f2L0000009f9kQAA","a6f2L0000009f9lQAA","a6f2L0000009fM5QAI","a6f2L0000009fMAQAY","a6f2L0000009cHDQAY","a6f2L0000009bhAQAQ","a6f2L0000009bhFQAQ","a6f2L0000009cb3QAA","a6f2L0000009ckeQAA","a6f2L0000009ckoQAA","a6f2L0000009dE5QAI","a6f2L0000009dE6QAI","a6f2L0000009ey9QAA","a6f2L0000009ezSQAQ","a6f2L0000009fklQAA","a6f2L0000009bhyQAA","a6f2L0000009cJ4QAI","a6f2L0000009dFSQAY","a6f2L0000009dRsQAI","a6f2L0000009dRxQAI","a6f2L0000009e41QAA","a6f2L0000009eIxQAI","a6f2L0000009eQwQAI","a6f2L0000009eR1QAI","a6f2L0000009eR6QAI","a6f2L0000009ejTQAQ","a6f2L0000009fLvQAI","a6f2L0000009bzdQAA","a6f2L0000009bzeQAA","a6f2L0000009bziQAA","a6f2L0000009ebLQAQ","a6f2L0000009ebMQAQ","a6f2L0000009cQZQAY","a6f2L0000009ciEQAQ","a6f2L0000009cjHQAQ","a6f2L0000009dFhQAI","a6f2L0000009dFiQAI","a6f2L0000009dFmQAI","a6f2L0000009dFnQAI","a6f2L0000009dFrQAI","a6f2L0000009dFsQAI","a6f2L0000009dFwQAI","a6f2L0000009dFxQAI","a6f2L0000009dG1QAI","a6f2L0000009dG2QAI","a6f2L0000009dG6QAI","a6f2L0000009dG7QAI","a6f2L0000009dGBQAY","a6f2L0000009dGCQAY","a6f2L0000009dGGQAY","a6f2L0000009dGHQAY","a6f2L0000009dGLQAY","a6f2L0000009dGMQAY","a6f2L0000009dGVQAY","a6f2L0000009dGWQAY","a6f2L0000009dGaQAI","a6f2L0000009dGbQAI","a6f2L0000009dGfQAI","a6f2L0000009dGgQAI","a6f2L0000009dGkQAI","a6f2L0000009dGlQAI","a6f2L0000009dGpQAI","a6f2L0000009dGqQAI","a6f2L0000009dGuQAI","a6f2L0000009dGvQAI","a6f2L0000009dGzQAI","a6f2L0000009dH0QAI","a6f2L0000009dH4QAI","a6f2L0000009dH5QAI","a6f2L0000009dH9QAI","a6f2L0000009dHAQAY","a6f2L0000009dHEQAY","a6f2L0000009dHFQAY","a6f2L0000009dHJQAY","a6f2L0000009dHKQAY","a6f2L0000009dHOQAY","a6f2L0000009dHPQAY","a6f2L0000009dHTQAY","a6f2L0000009dHUQAY","a6f2L0000009dHQQAY","a6f2L0000009dHRQAY","a6f2L0000009dHYQAY","a6f2L0000009dHZQAY","a6f2L0000009dPNQAY","a6f2L0000009dPOQAY","a6f2L0000009dxZQAQ","a6f2L0000009dxaQAA","a6f2L0000009ePZQAY","a6f2L0000009ePaQAI","a6f2L0000009ePtQAI","a6f2L0000009ePuQAI","a6f2L0000009eqPQAQ","a6f2L0000009eqQQAQ","a6f2L0000009erXQAQ","a6f2L0000009erYQAQ","a6f2L0000009erhQAA","a6f2L0000009eriQAA","a6f2L0000009ew3QAA","a6f2L0000009ew4QAA","a6f2L0000009f1TQAQ","a6f2L0000009f1UQAQ","a6f2L0000009f1YQAQ","a6f2L0000009f1ZQAQ","a6f2L0000009f1dQAA","a6f2L0000009f1eQAA","a6f2L0000009f1iQAA","a6f2L0000009f1jQAA","a6f2L0000009fAEQAY","a6f2L0000009fAFQAY","a6f2L0000009bnNQAQ","a6f2L0000009bnOQAQ","a6f2L0000009bnSQAQ","a6f2L0000009c86QAA","a6f2L0000009dEoQAI","a6f2L0000009dEpQAI","a6f2L0000009dO0QAI","a6f2L0000009dT0QAI","a6f2L0000009dT1QAI","a6f2L0000009f06QAA","a6f2L0000009f07QAA","a6f2L0000009flPQAQ","a6f2L0000009dFXQAY","a6f2L0000009dFYQAY","a6f2L0000009du6QAA","a6f2L0000009ew8QAA","a6f2L0000009etYQAQ","a6f2L0000009etZQAQ","a6f2L0000009etdQAA","a6f2L0000009eteQAA","a6f2L0000009etiQAA","a6f2L0000009etjQAA","a6f2L0000009etnQAA","a6f2L0000009etoQAA","a6f2L0000009etsQAA","a6f2L0000009ettQAA","a6f2L0000009ezNQAQ","a6f2L0000009ezOQAQ","a6f2L0000009f9LQAQ","a6f2L0000009f9MQAQ","a6f2L0000009eKoQAI","a6f2L0000009c9YQAQ","a6f2L0000009c9ZQAQ","a6f2L0000009e0xQAA","a6f2L0000009e0yQAA","a6f2L0000009esaQAA","a6f2L0000009esbQAA","a6f2L0000009eH6QAI","a6f2L0000009eMVQAY","a6f2L0000000ORHQA2","a6f2L0000000OSAQA2","a6f2L0000009bh5QAA","a6f2L0000009cFMQAY","a6f2L0000009cJiQAI","a6f2L0000009cJjQAI","a6f2L0000009cckQAA","a6f2L0000009dBVQAY","a6f2L0000009dmvQAA","a6f2L0000009e1WQAQ","a6f2L0000009eWaQAI","a6f2L0000000JAaQAM","a6f2L0000000JhdQAE","a6f2L0000009bbHQAQ","a6f2L0000009cHIQAY","a6f2L0000009cpFQAQ","a6f2L0000009dhCQAQ","a6f2L0000009dmgQAA","a6f2L0000009dmlQAA","a6f2L0000009dmqQAA","a6f2L0000009eJCQAY","a6f2L0000009fNDQAY","a6f2L0000009bxNQAQ","a6f2L0000009bxOQAQ","a6f2L0000009bxSQAQ","a6f2L0000009dUNQAY","a6f2L0000009eYlQAI","a6f2L0000009bkOQAQ","a6f2L0000009cQeQAI","a6f2L0000009f3ZQAQ","a6f2L0000009fAOQAY","a6f2L0000009fQHQAY","a6f2L0000009dB6QAI","a6f2L0000009dB7QAI","a6f2L0000009dBBQAY","a6f2L0000009eQ3QAI","a6f2L0000009eUZQAY","a6f2L0000009fLqQAI","a6f2L0000009fLrQAI","a6f2L0000009fmrQAA","a6f2L0000009fjsQAA"];
  @Input() disableProjectType = false;
  @Input() hasProjectSelected = false;
  @Input() checkByLoggedInUserProj = true;

  @Input() set resetData(isClear) {
    if (isClear) {
      this.taskSelectedList = [];
      this.taskOptionList = [];
    }
  }
  @Input() placeholder = 'Task';
  @Input() isdisabled;

  @Input()
  set isMultipleSelected(e) {
    this._multipleSelect = e;
    this.maxSelectedItems = e ? 20 : 1;
  }

  @Output() getTaskObj: EventEmitter<any> = new EventEmitter;
  public searchInput = new EventEmitter<string>();

  // setTaskObj will be the object, {'PgMo_Projects_c': [], 'PgMO_Milestones__c': []}
  @Input()
  set setTaskObj(params) {
    this.taskOptionList = [];
    this.clearTask();
    this.whereObj = this.whereObj && Object.keys(this.whereObj).length ? this.whereObj : {};
    // if (params && Object.keys(params).length) { // Commenting this as clear filter is not working properly due to this check.
      if (params['PgMO_Projects__c'] && params['PgMO_Projects__c'].length) {
        this.whereObj['PgMO_Projects__c'] = { inq: params['PgMO_Projects__c'] };
      } else if (this.consoleType && this.consoleType.length) {
        this.whereObj['PgMO_Projects__c'] = { inq: this.projectsByConsole };
      } else if (this.whereObj['PgMO_Projects__c']) {
        delete this.whereObj['PgMO_Projects__c']
      }

      if (params['Account__c'] && params['Account__c'].length) {
        this.whereObj['Account__c'] = { inq: params['Account__c'] };
      } else {
        if (this.whereObj['Account__c']) {
          delete this.whereObj['Account__c'];
        }
      }

      if (params['PgMO_Milestones__c'] && params['PgMO_Milestones__c'].length) {
        this.whereObj['PgMO_Milestones__c'] = { inq: params['PgMO_Milestones__c'] };
      } else {
        if (this.whereObj['PgMO_Milestones__c']) {
          delete this.whereObj['PgMO_Milestones__c'];
        }
      }
    // }
  }
  @Input() set selectedConversatonTask(e) {
    if (e) {
      this.selectedTask = e;
    } else {
      this.selectedTask = '';
    }
  }

  @Input() set setProjectConsoleType(e) {
    if(e) {
      if(e.length) {
        this.consoleType = e;
        this.getProjectsByConsole();
      }else{
        this.consoleType = [];
        this.projectsByConsole = null;
      }      
    }
  }

  @Input() set limitedOptionList(e) {
    if(e && e.length){
      this.isSearchable = false;
      this.taskOptionList = [];
      e.forEach(item => {
        item['label'] = item.Task_Number__c ? item.Task_Number__c + ' - ' : '';
        item.label += item.Name;
        this.taskOptionList.push(item);
      });
    }
  }

  isSearchable = true;
  selectedTask: any;
  whereObj = {};
  _multipleSelect = true;
  maxSelectedItems = 20;

  taskOptionList = [];
  taskSelectedList = [];

  /**
   * @constructor
   * Represents a TaskLookupComponent.
   */
  constructor(
    private _taskApi: TaskApi,
    private _deliveryManagerService: DeliveryManagerService
  ) {
  }

  ngOnInit() {    
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    if (preselected && preselected['tasks'] && preselected['tasks'].length ) {
      this.taskSelectedList = preselected['tasks'];
      this.onTaskChange();
      const whereObj = this.whereObj;
      whereObj['sfdcId'] = { inq: this.taskSelectedList };
      const filterObj = {
        where: whereObj,
        fields: ['id', 'sfdcId', 'Name', 'Account__c', 'PgMO_Milestones__c', 'PgMO_Projects__c', 'Task_No__c', 'Task_Number__c'],
        order: 'createdAt desc',
        limit: 200
      }
      this.isLoading = true;
      this._taskApi.find(filterObj).subscribe(data => {
        this.isLoading = false;
        if (data && data.length) {
          data.forEach((item: any) => {
            item.label = item.Task_Number__c ? item.Task_Number__c + ' - ' : '';
            item.label += item.Name;
          })
          this.taskOptionList = data;

        } else {
          this.taskOptionList = [];
        }
      }, error => {
        this.isLoading = false;
        this.taskOptionList = [];
        console.log(error);
      })
    }

    // if (preselected && preselected['milestones'] && preselected['milestones'].length) {
    //   this.whereObj['PgMO_Milestones__c'] = { inq: preselected['milestones'] };
    // }
    // if (preselected && preselected['projects'] && preselected['projects'].length) {
    //   this.whereObj['PgMO_Projects__c'] = { inq: preselected['projects'] };
    // }
    // this.getTasks(this.whereObj);
    this.getTaskObj.emit(this.taskSelectedList);
    this.getTaskList();
    if (this.selectedTask) {
      this.taskSelectedList = this.selectedTask && this.selectedTask.sfdcId;
      this.formatSelectedTask();
    }
    if (this.checkByLoggedInUserProj && !this._deliveryManagerService.isAdmin()) {
      this._deliveryManagerService.getCurrentUserGroupIds({ project: [] }).then(projs => {
        this.projectsByLoggedInUser = projs
      });
    }
  }

  prepareWhereClause() {
    if (this.projectsByLoggedInUser) {
      let projectSfdcIds: Array<string>;
      if (this.whereObj && this.whereObj['PgMO_Projects__c'] && this.whereObj['PgMO_Projects__c']['inq']) {
        projectSfdcIds = this.whereObj['PgMO_Projects__c']['inq'].filter(sfdcId => this.projectsByLoggedInUser.includes(sfdcId))
      } else {
        projectSfdcIds = this.projectsByLoggedInUser
      }
      this.whereObj['PgMO_Projects__c'] = { inq: projectSfdcIds }
    }
    return this.whereObj;
  }

  getTaskList() {
    this.searchInput
      .pipe(
        filter(search => search && search.trim().length >= 3),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(search =>
          //this.getTasks(this.whereObj, search)
          this._getTasksRecursively(this.prepareWhereClause(), search)
        )
      ).subscribe(
        data => {
          this.isLoading = false;
          if (data && data.length) {
            data.forEach((item: any) => {
              item.label = item.Task_Number__c ? item.Task_Number__c + ' - ' : '';
              item.label += item.Name;
            })
            this.taskOptionList = data;

          } else {
            this.taskOptionList = [];
          }
        },
        err => {
          this.isLoading = false;
          console.log(err);
          this.taskOptionList = [];
        }
      );
  }

  private _getTasksRecursively(where, search) {
    this.isLoading = true;
    let whereNew = JSON.parse(JSON.stringify(where));
    if(whereNew && whereNew['PgMO_Projects__c'] && whereNew['PgMO_Projects__c'].inq && whereNew['PgMO_Projects__c'].inq.length){
      const array_chunks = (array, chunk_size) => Array(Math.ceil(array.length / chunk_size)).fill('').map((_, index) => index * chunk_size).map(begin => array.slice(begin, begin + chunk_size));
      var project_chunks = [];
      if(whereNew['PgMO_Projects__c'] && whereNew['PgMO_Projects__c'].inq && whereNew['PgMO_Projects__c'].inq.length){
        project_chunks = array_chunks(whereNew['PgMO_Projects__c'].inq, 200);
      }
      var totalChunks = project_chunks.length;
      var counter = 1;
      whereNew['PgMO_Projects__c'].inq = project_chunks[counter - 1];
      return this.getTasks(whereNew, search).expand((obj) => {
        if(counter < totalChunks){
          counter++;
          whereNew['PgMO_Projects__c'].inq = project_chunks[counter - 1];          
          return this.getTasks(whereNew, search);          
        }else{
          return EMPTY;
        }
      }).map(obj => obj).flatMap(array => array).reduce((acc, x) => acc.concat(x), []);
    }else{
      return this.getTasks(whereNew, search);
    }
  }

  getProjectsByConsole() {
    if(this.consoleType && this.consoleType.length){
      this._deliveryManagerService.getProjectsByConsole(this.consoleType, true).then(data => {
        this.projectsByConsole = data;
        if(this.hasProjectSelected) {
          if(!(this.whereObj && this.whereObj['PgMO_Projects__c'] && this.whereObj['PgMO_Projects__c'].inq && this.whereObj['PgMO_Projects__c'].inq)){
            const preSelected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
            if (preSelected && preSelected['projects'] && preSelected['projects'].length) {
              this.whereObj['PgMO_Projects__c'] = {inq: preSelected['projects']};
            }
          }
        } else {
          if(this.projectsByConsole && this.projectsByConsole.length) {
            this.whereObj['PgMO_Projects__c'] = {inq: this.projectsByConsole};
          }
        }
      });
    }
  }

  getTasks(whereObj, search) {
    let andObj = [];
    if (whereObj['sfdcId']) {
      delete whereObj['sfdcId'];
    }
    if(whereObj['PgMO_Projects__c'] && Object.keys(whereObj['PgMO_Projects__c']).length === 0 ){
      delete whereObj['PgMO_Projects__c'];
    }
    if (Object.keys(whereObj).length) {
      andObj = Object.keys(whereObj).map(function (itemIndexed) { const item = whereObj[itemIndexed]; return {[itemIndexed]: item}; })
      andObj.push({
        or: [
          { Name: { like: '%' + search.trim() + '%', options: 'i' } },
          { Task_Number__c: { like: '%' + search.trim() + '%', options: 'i' } }
        ]
      });
    } else {
      andObj = [{
        or: [
          { Name: { like: '%' + search.trim() + '%', options: 'i' } },
          { Task_Number__c: { like: '%' + search.trim() + '%', options: 'i' } }
        ]
      }];
    }
    const filterObj = {
      where: {and: andObj},
      fields: ['id', 'sfdcId', 'Name', 'Account__c', 'PgMO_Milestones__c', 'PgMO_Projects__c', 'Task_No__c', 'Task_Number__c'],
      order: 'createdAt desc',
      limit: 200
    }

    return this._taskApi.find(filterObj);
  }

  formatSelectedTask() {
    this.selectedTask.label = this.selectedTask.Task_Number__c ? this.selectedTask.Task_Number__c + ' - ' : '';
    this.selectedTask.label += this.selectedTask.Name;
    this.taskOptionList = [];
    this.taskOptionList.push(this.selectedTask);
    this.getTaskObj.emit(this.taskSelectedList);
  }

  onTaskChange() {
    this.getTaskObj.emit(this.taskSelectedList);
  }

  clearTask() {
    this.taskSelectedList = [];
    this.getTaskObj.emit([]);
  }
}
